module.exports = __webpack_public_path__ + "static/ARCLG-522eb04a1ce583c698a69bbbabaf41ab.png";